/**
 * Token Management - Single source of truth
 * Handles reading/writing auth tokens from all possible storage locations
 */

export const TOKEN_KEYS = ["token", "accessToken", "jwt", "authToken"];

/**
 * Read token from storage - checks multiple possible key names
 */
export function readToken() {
  try {
    for (const k of TOKEN_KEYS) {
      const a = localStorage.getItem(k);
      if (a) return a;
      const b = sessionStorage.getItem(k);
      if (b) return b;
    }
  } catch {}
  return "";
}

/**
 * Write token to storage
 */
export function writeToken(token) {
  try {
    localStorage.setItem("token", token);
  } catch {}
}

/**
 * Clear all possible token keys from storage
 */
export function clearToken() {
  try {
    for (const k of TOKEN_KEYS) {
      localStorage.removeItem(k);
      sessionStorage.removeItem(k);
    }
  } catch {}
}

/**
 * Check if user appears to be logged in (has any token)
 */
export function hasToken() {
  return Boolean(readToken());
}

export default { readToken, writeToken, clearToken, hasToken, TOKEN_KEYS };
